export const collectionImageSequence = ["campaignImages"];

export const reccsImageSequence = ["campaignImages"];

export const productImageSequence = [
  "campaignImages",
  "campaignSecondaryImages",
  "campaignVideos",
  "ecomVideos",
  "ecomImages",
  "ecomBack",
  "ecomSide",
  "ecomCloseUpImages",
  "flatlayImages",
  "flatlayBack",
];

export const indexFeaturedProductsSequence = ["ecomImages"];
